"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "browser", {
  enumerable: true,
  get: function () {
    return _browser.default;
  }
});
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function () {
    return _capitalize.default;
  }
});
Object.defineProperty(exports, "chronos", {
  enumerable: true,
  get: function () {
    return _chronos.default;
  }
});
Object.defineProperty(exports, "dateFormat", {
  enumerable: true,
  get: function () {
    return _dateFormat.default;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function () {
    return _debounce.default;
  }
});
Object.defineProperty(exports, "formatCurrency", {
  enumerable: true,
  get: function () {
    return _formatCurrency.default;
  }
});
Object.defineProperty(exports, "generateNumberId", {
  enumerable: true,
  get: function () {
    return _generateNumberId.default;
  }
});
Object.defineProperty(exports, "getBordersStyles", {
  enumerable: true,
  get: function () {
    return _getBordersStyles.default;
  }
});
Object.defineProperty(exports, "getErrorMessage", {
  enumerable: true,
  get: function () {
    return _getErrorMessage.default;
  }
});
Object.defineProperty(exports, "getFileSize", {
  enumerable: true,
  get: function () {
    return _getFileSize.default;
  }
});
Object.defineProperty(exports, "getObjectField", {
  enumerable: true,
  get: function () {
    return _getObjectField.default;
  }
});
Object.defineProperty(exports, "getURLSearchParams", {
  enumerable: true,
  get: function () {
    return _getURLSearchParams.default;
  }
});
Object.defineProperty(exports, "groupArrayByPath", {
  enumerable: true,
  get: function () {
    return _groupArrayByPath.default;
  }
});
Object.defineProperty(exports, "hexToRGBA", {
  enumerable: true,
  get: function () {
    return _hexToRGBA.default;
  }
});
Object.defineProperty(exports, "isBrowser", {
  enumerable: true,
  get: function () {
    return _isBrowser.default;
  }
});
Object.defineProperty(exports, "isDate", {
  enumerable: true,
  get: function () {
    return _isDate.default;
  }
});
Object.defineProperty(exports, "isDecimalNumber", {
  enumerable: true,
  get: function () {
    return _isDecimalNumber.default;
  }
});
Object.defineProperty(exports, "isNumber", {
  enumerable: true,
  get: function () {
    return _isNumber.default;
  }
});
Object.defineProperty(exports, "isObject", {
  enumerable: true,
  get: function () {
    return _isObject.default;
  }
});
Object.defineProperty(exports, "isObjectEmpty", {
  enumerable: true,
  get: function () {
    return _isObjectEmpty.default;
  }
});
Object.defineProperty(exports, "isValidRun", {
  enumerable: true,
  get: function () {
    return _isValidRun.default;
  }
});
Object.defineProperty(exports, "localStorage", {
  enumerable: true,
  get: function () {
    return _localStorage.default;
  }
});
Object.defineProperty(exports, "normalizeHtmlText", {
  enumerable: true,
  get: function () {
    return _normalizeHtmlText.default;
  }
});
Object.defineProperty(exports, "rutFormat", {
  enumerable: true,
  get: function () {
    return _rutFormat.default;
  }
});
Object.defineProperty(exports, "slugify", {
  enumerable: true,
  get: function () {
    return _slugUtils.slugify;
  }
});
Object.defineProperty(exports, "sortArrayByPath", {
  enumerable: true,
  get: function () {
    return _sortArrayByPath.default;
  }
});
Object.defineProperty(exports, "stringInterpolator", {
  enumerable: true,
  get: function () {
    return _stringInterpolator.default;
  }
});
Object.defineProperty(exports, "unslugify", {
  enumerable: true,
  get: function () {
    return _slugUtils.unslugify;
  }
});
exports.yup = void 0;
Object.defineProperty(exports, "yupResolver", {
  enumerable: true,
  get: function () {
    return _yup.yupResolver;
  }
});
var _yup = require("@hookform/resolvers/yup");
var yup = _interopRequireWildcard(require("yup"));
exports.yup = yup;
var _hexToRGBA = _interopRequireDefault(require("./hexToRGBA"));
var _isValidRun = _interopRequireDefault(require("./isValidRun"));
var _isBrowser = _interopRequireDefault(require("./isBrowser"));
var _isObjectEmpty = _interopRequireDefault(require("./isObjectEmpty"));
var _rutFormat = _interopRequireDefault(require("./rutFormat"));
var _debounce = _interopRequireDefault(require("./debounce"));
var _capitalize = _interopRequireDefault(require("./capitalize"));
var _formatCurrency = _interopRequireDefault(require("./formatCurrency"));
var _chronos = _interopRequireDefault(require("./chronos"));
var _dateFormat = _interopRequireDefault(require("./chronos/dateFormat"));
var _getErrorMessage = _interopRequireDefault(require("./getErrorMessage"));
var _getObjectField = _interopRequireDefault(require("./getObjectField"));
var _getBordersStyles = _interopRequireDefault(require("./getBordersStyles"));
var _getFileSize = _interopRequireDefault(require("./getFileSize"));
var _localStorage = _interopRequireDefault(require("./browser/local-storage"));
var _stringInterpolator = _interopRequireDefault(require("./stringInterpolator"));
var _isNumber = _interopRequireDefault(require("./isNumber"));
var _isDecimalNumber = _interopRequireDefault(require("./isDecimalNumber"));
var _isObject = _interopRequireDefault(require("./isObject"));
var _isDate = _interopRequireDefault(require("./isDate"));
var _groupArrayByPath = _interopRequireDefault(require("./groupArrayByPath"));
var _slugUtils = require("./slug-utils");
var _sortArrayByPath = _interopRequireDefault(require("./sortArrayByPath"));
var _normalizeHtmlText = _interopRequireDefault(require("./normalizeHtmlText"));
var _getURLSearchParams = _interopRequireDefault(require("./getURLSearchParams"));
var _generateNumberId = _interopRequireDefault(require("./generateNumberId"));
var _browser = _interopRequireDefault(require("./browser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Todo: Everything has to be done throught chronos when migrating to @wicadu/utils

// TODO: Everything has to be done throught browser when migrating to @wicadu/utils

yup.addMethod(yup.string, 'wicaduEmail', function validateEmail(message) {
  return this.matches("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$", {
    message,
    name: 'wicaduEmail',
    excludeEmptyString: true
  }).transform(email => "".concat(email).toLowerCase());
});